// extracted by mini-css-extract-plugin
module.exports = {"header":"_04885a0"};